
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "1024",
    "height": "1024",
    "viewBox": "0 0 1024 1024"
  },
  "children": [
    {
      "tag": "title"
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "icomoon-ignore"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M1024 701v-504q0-53-26.5-98t-72-71.5-98.5-26.5h-630q-53 0-98.5 26.5t-72 71.5-26.5 98v630q0 54 26.5 99t72 71.5 98.5 26.5h630q47 0 88.5-21t69-58 36.5-83l-6-2q-276-120-391-174-71 86-143 127-81 46-182 46-69 0-123-26-53-26-80-70.5t-21-97.5q4-43 25-78 28-45 79-68 64-27 160-18 65 6 119 19 33 8 100 31l31 10q35-64 57-139h-398v-40h197v-70h-240v-44h240v-102l1-4q2-5 6.5-8.5t12.5-3.5h98v118h256v44h-256v70h209q-29 116-85 213 38 14 191 61l146 45M284 792q-69 0-111-26-35-21-48-56-12-28-7-52 5-21 20-41 18-22 45-35 31-15 70-15 70 0 139 19 66 18 145 56-55 72-119 110-66 40-134 40z"
      }
    }
  ]
})
    }
  